<ng-container>
  @if ((digitizationParameters$ | async); as digitizationParameters) {
    @if ((imageData$ | async); as imageData) {
      <div class="container-fluid" [ngClass]="{'documents': (sectionToDisplay$ | async) === 'Documents'}">
        @if ((sectionToDisplay$ | async) === 'Documents') {
          <app-endorsements-sidenav
            (generateEndorsementComponent)="handleEndorsementComponentOutput($event)"
            (generateEndorsementUsingTemplate)="handleGenerateEndorsementUsingTemplate($event)"
            (generateNotaryEndorsementComponent)="handleGenerateNotaryEndorsementComponent($event)"
            (openSaveTemplateModalForTemplateName)="handleOpenSaveTemplateModalForTemplateName($event)"
            (submitDocumentAndEndorsements)="handleSubmitDocumentAndEndorsements($event)"
            (updateTemplateEndorsements)="handleUpdateTemplateEndorsements($event)"
            (templateShareModalRequested)="openTemplateShareModal()"
            (deleteTemplateConfirmation)="deleteTemplateConfirmation($event)"
            [digitizationParameters$]="digitizationParameters$"
            [imageData$]="imageData$"
            [order]="order"
            [participants$]="participants$"
            [templateID]="templateID"
            [templateOptions$]="templateOptions$"
          ></app-endorsements-sidenav>
        }
        <div #documentDisplayContainer class="row">
          <div class="ribbon-bar" [ngClass]="{'documents': (sectionToDisplay$ | async) === 'Documents'}">
            @if ((ribbonTabToDisplay$ | async); as ribbonTabToDisplay) {
              @if (ribbonTabToDisplay === 'Document') {
              <div>
                <app-document-edit-form
                  [order]="order"
                  [documents]="(digitizationParameters$ | async)?.myDocuments"
                  [ruleViolations]="ruleViolations"
                  [selectedDocumentId]="selectedDocumentId"
                  (exitDocumentEditor)="exitDocumentEditor()"
                  (updateReviewedByAttribute)="updateReviewedByAttribute($event)"
                  (selectDocument)="onDocumentSelected($event)"
                  >
                </app-document-edit-form>
              </div>
            }
            @if (ribbonTabToDisplay === 'Apply') {
              <div id="applyTab">
                <div class="ribbon-collection no-border">
                  <div class="ribbon-collection-items">
                    <div class="ribbon-item-row">
                      <div class="ribbon-item fullwidth">
                        <mat-form-field id="digiDocTemplateId" class="clrsgn-form-field" appearance="fill">
                          <mat-label class="clrsgn-label">Apply Template</mat-label>
                          <mat-select data-cy="selectTemplateDropdown" [(ngModel)]="digitizationParameters.selectedTemplate"
                            (selectionChange)="generateEndorsementsUsingTemplate($event.value, imageData)">
                            @if ((templateOptions$ | async).length === 0) {
                              <mat-option disabled>No Template Created</mat-option>
                            }
                            @for (template of (templateOptions$ | async); track template) {
                              <mat-option [value]="template.key">{{ template.value }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        @if (templateID) {
                          <span>Template ID: {{ templateID }}</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ribbon-collection no-border">
                  <div class="ribbon-collection-items">
                    <div class="ribbon-item-col">
                      @if ((participants$ | async); as participants) {
                        <button class="btn-secondary digidoc-button center" (click)="openSaveTemplateModalForTemplateName(imageData, digitizationParameters, participants)">
                          Save Template As
                        </button>
                      } @else {
                        <button class="btn-secondary digidoc-button center" [disabled]>
                          Save Template As
                        </button>
                      }
                      @if ((participants$ | async); as participants) {
                        <button class="btn-primary digidoc-button center" (click)="updateTemplateEndorsements(imageData, digitizationParameters, digitizationParameters.selectedTemplate, participants)">
                          Save Template Changes
                        </button>
                      } @else {
                        <button class="btn-primary digidoc-button center" [disabled]>
                          Save Template Changes
                        </button>
                      }
                    </div>
                  </div>
                </div>
                @if ((getParticipants() | async); as participants) {
                  <div class="ribbon-collection">
                    <div class="ribbon-collection-items">
                      <div class="ribbon-item-col">
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="signatureDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Signature
                            </button>
                            <div ngbDropdownMenu aria-labelledby="signatureDropdown">
                              @for (participant of participants; track participant) {
                                <button [disabled]="!participantCanParticipate(participant)" ngbDropdownItem (click)="generateEndorsementComponent(participant, imageData, false, 'SIGNATURE')">
                                  {{ participant | participantSignatureName }} - <span class="primary-color-txt">{{participant.role | roleValue}}</span>
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="initialsDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Initials
                            </button>
                            <div ngbDropdownMenu aria-labelledby="initialsDropdown">
                              @for (participant of participants; track participant) {
                                <button [disabled]="!participantCanParticipate(participant)" ngbDropdownItem (click)="generateEndorsementComponent(participant, imageData, false, 'INITIALS')">
                                  {{ participant | participantSignatureName }} - <span class="primary-color-txt">{{participant.role | roleValue}}</span>
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ribbon-item-col">
                        <div class="ribbon-item">
                          <button class="btn text-button" [disabled]="endorsmentDisabledForOrder()" type="button" aria-label="Stamp" (click)="generateNotaryEndorsement(imageData, participants)">
                            Stamp
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="ribbon-collection-name">
                      Endorsements
                    </div>
                  </div>
                  <div class="ribbon-collection">
                    <div class="ribbon-collection-items">
                      <div class="ribbon-item-col">
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="textboxDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Textbox
                            </button>
                            <div ngbDropdownMenu aria-labelledby="textboxDropdown">
                              @for (participant of participants; track participant) {
                                <a ngbDropdownItem [disabled]="!participantCanParticipate(participant)" (click)="generateEndorsementComponent(participant, imageData, false, 'TEXTBOX')">{{ participant | participantDisplayName }} - <span class="primary-color-txt">{{participant.role | roleValue}}</span></a>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="checkboxDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Checkbox
                            </button>
                            <div ngbDropdownMenu aria-labelledby="checkboxDropdown">
                              @for (participant of participants; track participant) {
                                <button ngbDropdownItem [disabled]="!participantCanParticipate(participant)" (click)="generateEndorsementComponent(participant, imageData, false, 'CHECKBOX')">{{ participant | participantDisplayName }} - <span class="primary-color-txt">{{participant.role | roleValue}}</span></button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ribbon-item-col">
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="textboxOptionalDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Textbox - Optional
                            </button>
                            <div ngbDropdownMenu aria-labelledby="textboxOptionalDropdown">
                              @for (participant of participants; track participant) {
                                <button ngbDropdownItem [disabled]="!participantCanParticipate(participant)" (click)="generateEndorsementComponent(participant, imageData, false, 'TEXTBOX', null, 0, 0, 0, 0, false)">{{ participant | participantDisplayName }} - <span class="primary-color-txt">{{participant.role | roleValue}}</span></button>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="checkboxOptionalDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Checkbox - Optional
                            </button>
                            <div ngbDropdownMenu aria-labelledby="checkboxOptionalDropdown">
                              @for (participant of participants; track participant) {
                                <button ngbDropdownItem [disabled]="!participantCanParticipate(participant)" (click)="generateEndorsementComponent(participant, imageData, false, 'CHECKBOX', null, 0, 0, 0, 0, false)">
                                  {{ participant | participantDisplayName }} - <span class="primary-color-txt">{{participant.role | roleValue}}</span>
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ribbon-collection-name">
                      Inputs
                    </div>
                  </div>
                  <div class="ribbon-collection">
                    <div class="ribbon-collection-items">
                      <div class="ribbon-item-col">
                        <div class="ribbon-item">
                          <button class="btn text-button" type="button" aria-label="State" (click)="generateEndorsementComponent(null, imageData, true, 'STATE')">
                            State
                          </button>
                        </div>
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" type="button" id="dateDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Date
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dateDropdown">
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'MM/dd/yyyy')">Full Date (MM/dd/yyyy)</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'yyyy')">Four Digit Year (yyyy)</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'yy')">Two Digit Year (yy)</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'dd')">Day Of Month (dd)</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'MMMM')">Month Name (January)</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'MMM')">Month Abbreviated (Jan)</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'DATE', 'MM')">Month Number (MM)</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ribbon-item-col">
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" [disabled]="endorsmentDisabledForOrder()" type="button" id="signingAgentFieldsdropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Signing Agent Fields
                            </button>
                            <div ngbDropdownMenu aria-labelledby="signingAgentFieldsdropdown">
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'SIGNINGAGENTCOUNTY')">Signing Agent County</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'SIGNINGAGENTNAME')">Signing Agent Name</button>
                            </div>
                          </div>
                        </div>
                        <div class="ribbon-item">
                          <div ngbDropdown>
                            <button class="btn text-button dropdown-toggle" [disabled]="endorsmentDisabledForOrder()" type="button" id="commissionFieldsDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                              Commission Fields
                            </button>
                            <div ngbDropdownMenu aria-labelledby="commissionFieldsDropdown">
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'SIGNINGAGENTCOMMEXPIRE')">Commission Expiration Date</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'SIGNINGAGENTCOMMNUMBER')">Commission Number</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'SIGNINGAGENTCOMMCOUNTY')">Commission County</button>
                              <button ngbDropdownItem (click)="generateEndorsementComponent(null, imageData, true, 'SIGNINGAGENTCOMMSTATE')">Commission State</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ribbon-collection-name">
                      System Generated
                    </div>
                  </div>
                }
              </div>
            }
          }
        </div>
        @if ((sectionToDisplay$ | async) === 'Documents') {
          <section class="documentdisplay"
              >
              <div class="documents-flex"></div>
              <div class="imageContainerSection">
                <div class="imageContainer">
                  <img #docImage [src]="imageData.src" [hidden]="!imageData.src" class="documentImageCss" alt="" />
                  @if ((imageOverlayDivDimensions$ | async); as imageOverlayDimensions) {
                    <div #imageDivOverlay>
                      <ng-container #ec></ng-container>
                    </div>
                  }
                </div>
              </div>
              <div class="documents-flex"></div>
            </section>
          }
      </div>
    </div>
  }
  <ng-template #loading>
    Page Loading
  </ng-template>
}
</ng-container>
